<template>
    <CompassEmptyState :title="translations.title" :caption="translations.caption">
        <CompassButton
            v-if="showButton"
            :label="translations.actions.refresh_page"
            type="secondary"
            @click="refreshPage"
        />
    </CompassEmptyState>
</template>

<script>
export default {
    props: {
        showButton: {
            type: Boolean,
            default: true,
        },
    },
    data() {
        return {
            translations: {
                title: this.$t.__('automation.AutomationEmptyStateDisconnectedToProvider.title'),
                caption: this.$t.__(
                    'automation.AutomationEmptyStateDisconnectedToProvider.caption',
                ),
                actions: {
                    refresh_page: this.$t.__('common.labels.refresh_page'),
                },
            },
        };
    },
    methods: {
        refreshPage() {
            window.location.reload();
        },
    },
};
</script>
